export enum CL_COUNTRIES {
  CO = "co",
  EC = "ec",
  MX = "mx",
  PA = "pa",
  PE = "pe",
  US = "us",
}

export enum CL_COUNTRY {
  CO = "CO",
  EC = "EC",
  MX = "MX",
  PA = "PA",
  PE = "PE",
  US = "US",
}
